<template>
  <div class="container">
    <img class="ranking" src="../../assets/images/extra-style/ranking.png" @touchstart="hanldeViewRanking">
    <pages-wrapper>
      <div class="template-wrapper" v-for="(photo, index) in photoList" :key="index">
        <photo-template :photo="photo" @touchstart.native="previewPhoto(photo.photoId)"></photo-template>
        <div class="support-count">
          <img src="../../assets/images/extra-style/like.png">
          <span>{{ photo.supportCount }}</span>
        </div>
      </div>
      <div class="no-data" v-if="photoList.length === 0">
        暂无上传照片
      </div>
      <img class="add-btn" src="../../assets/images/extra-style/add-btn.png" @touchstart="hanldeAddPhoto">
    </pages-wrapper>
    <div class="return-btn">
      <img src="../../assets/images/extra-style/return.png" @touchstart="hanldeReturnIndex">
    </div>
  </div>
</template>

<script>
import PagesWrapper from './components/pages-wrapper'
import PhotoTemplate from './components/photo-template'
import extraStyleApi from '@/api/extra-style'
import { userUtils } from '@/utils/auth'
export default {
  name: 'ExtraStyleCenter',
  components: {
    PhotoTemplate,
    PagesWrapper
  },
  data () {
    return {
      userInfo: null,
      photoList: []
    }
  },
  created () {
    this.queryPhotoList()
  },
  methods: {
    queryPhotoList () {
      this.$toast({ mask: true, message: '加载中。。。' })
      this.userInfo = userUtils.getClientInfo()
      const params = {
        clientId: this.userInfo ? this.userInfo.clientId : ''
      }
      extraStyleApi.queryExtraStylePhotoList(params).then((response) => {
        if (response.data.resultCode === '0') {
          this.$toast.clear()
          this.photoList = response.data.resultData.photoList || []
        }
      })
    },
    hanldeViewRanking () {
      this.$router.push({ name: 'extra-style-ranking' })
    },
    hanldeAddPhoto () {
      const acticityTime = this.checkedActivityTime()
      console.log('acticityTime', acticityTime)
      if (!acticityTime) return
      extraStyleApi.queryExtraStyleAuthorize().then((response) => {
        if (response.data.resultCode === '0') {
          const count = response.data.resultData.count
          if (count > 0) {
            this.$router.push({ name: 'extra-style-template' })
          } else {
            this.$dialog.confirm({
              title: '授权提示',
              message: '本人自愿将肖像权许可易加网在活动期间做符合法律规定的用途，并在特定范围内传播。'
            }).then(() => {
              // on confirm
              extraStyleApi.saveExtraStyleAuthorize().then((response) => {
                if (response.data.resultCode === '0') {
                  this.$dialog.alert({ message: '授权成功' }).then(() => {
                    this.$router.push({ name: 'extra-style-template' })
                  })
                }
              })
            }).catch(() => {
              // on cancel
              this.$dialog.alert({ message: '授权失败' })
            })
          }
        }
      })
    },
    hanldeReturnIndex () {
      console.log('return')
      this.$router.push({ name: 'extra-style' })
    },
    // 预览照片
    previewPhoto (photoId) {
      console.log('preview', photoId)
      const query = {
        photoId: photoId
      }
      this.$router.push({ path: '/extra-style/photo-preview', query: query })
    },
    // 检查活动时间
    checkedActivityTime () {
      const currentTime = new Date().getTime()
      const startTime = new Date('2020/02/25 00:00:00').getTime()
      const endTime = new Date('2020/12/14 00:00:00').getTime()
      if (currentTime < startTime) {
        this.$toast({ message: '活动尚未开始' })
        return false
      }
      if (currentTime > endTime) {
        this.$toast({ message: '活动已结束' })
        return false
      }
      if (currentTime < endTime && currentTime > startTime) {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  height: calc(100vh);
  img {
    width: 100%;
  }
  .ranking {
    z-index: 3;
    position: absolute;
    top: 50px;
    right: 0;
    width: 80px;
  }
  .template-wrapper {
    width: 48%;
    padding: 10px 1% 0 1%;
    .support-count {
      padding-top: 5px;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #de412c;
      text-align: right;
      img {
        width: 15px;
        vertical-align: bottom;
      }
      span {
        display: inline-block;
        padding: 0 8px;
      }
    }
  }
  .no-data {
    width: 100%;
    line-height: 300px;
    font-size: 20px;
    color:#2e636b;
    text-align: center
  }
  .add-btn {
    z-index: 3;
    position: fixed;
    bottom: 10px;
    right: 10px;
    width: 50px;
  }
}
.return-btn {
  padding: 10px 0;
  text-align: center;
  background: url('../../assets/images/extra-style/bg.jpg') no-repeat;
  background-size: 100% 100%;
  img {
    width: 120px;
  }
}
</style>
